module.exports = __webpack_public_path__ + "img/CrimsonText-SemiBoldItalic.57f2a7d3.svg";